import React, { useEffect, useState } from "react";
import "./AuthForm.scss";
import AuthMode from "./components/Auth/AuthMode";
// import vk_icon from "./../../../../images/new_auth/vk_icon.svg";
// import yandex_icon from "./../../../../images/new_auth/yandex_icon.svg";
import { useSelector } from "react-redux";
import variableLanguage from "../../../../utils/hookGetVariablesLanguage";
import LanguageSelectNew from "../LanguageSelectNew";
import RegMode from "./components/Register/RegMode";

const AuthFormNew = ({ sessionId, defaultMode = "auth" }) => {
  const { language } = useSelector((state) => state.Reducer);

  const variables_1 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_1",
  });
  const variables_60 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_60",
  });
  const variables_61 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_61",
  });
  const variables_62 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_62",
  });

  const [mode, setMode] = useState(defaultMode);
  const [toggleHeaderFoter, setToggleHeaderFoter] = useState(true);
  const [activeLanguage, setActiveLanguage] = useState(null);
  useEffect(() => {
    setActiveLanguage(language === "en" ? 1 : 0);
    if (language) localStorage.setItem("language", language);
  }, [language]);
  return (
    <div className="AuthForm">
      {/* Заголовк формы */}
      {toggleHeaderFoter && (
        <div className="title">
          {mode === "auth" ? variables_1 : variables_60}
        </div>
      )}
      {mode === "auth" ? (
        <AuthMode
          setToggleHeaderFoter={setToggleHeaderFoter}
          toggleHeaderFoter={toggleHeaderFoter}
          sessionId={sessionId}
        />
      ) : (
        <RegMode
          setToggleHeaderFoter={setToggleHeaderFoter}
          toggleHeaderFoter={toggleHeaderFoter}
          sessionId={sessionId}
        />
      )}

      {toggleHeaderFoter && (
        <LanguageSelectNew activeLanguage={activeLanguage} />
      )}

      {/* {toggleHeaderFoter && (
        <>
          <div className="center">Или</div>
          <div className="auth-item pointer">
            <span className="auth-redirect">
              Войти через VK <img src={vk_icon} alt="vk_icon" />
            </span>
          </div>
          <div className="auth-item pointer">
            <span className="auth-redirect">
              Войти через Яндекс <img src={yandex_icon} alt="yandex_icon" />
            </span>
          </div>
        </>
      )} */}
      {/* Кнопка перехода на регистрацию */}
      {toggleHeaderFoter && (
        <div
          className="center violet pointer"
          onClick={() => {
            setMode(mode === "auth" ? "reg" : "auth");
            // setToggleHeaderFoter(false);
          }}
        >
          {mode === "auth" ? variables_61 : variables_62}
        </div>
      )}
    </div>
  );
};

export default AuthFormNew;
